export default ({ app, env }, inject) => {
  const CONFIG = {
    url: 'https://livechatv2.chat2desk.com',
    socket_url: 'wss://livechatv2.chat2desk.com/widget_ws_new',
    static_files_domain: 'https://storage.chat2desk.com',
    show_new_wysiwyg: 'true',
    lang: 'ru',
  };
  const isChatEnabled = Boolean(env.ENABLE_CHAT24);
  const isChatTokenFullFilled = Boolean(env.CHAT24_TOKEN);
  const isChatAvailable = isChatEnabled && isChatTokenFullFilled;

  function removeBlur() {
    const interval = setInterval(() => {
      const host = document.querySelector('#chat24-root chat-24');

      if (host) {
        const root = host.shadowRoot;

        if (root) {
          const container = host.shadowRoot.querySelector('.chat24-container');

          if (container) {
            const header = container.querySelector('.chat-header');
            const wrapper = container.querySelector('.offline-form-wrapper');

            if (header && wrapper) {
              header.classList.remove('chat-header--blurred');
              wrapper.style.height = '86%';

              clearInterval(interval);
              this.$chat24.removeBlur();
            }
          }
        }
      }
    }, 2000);
  }

  function chatInitialize() {
    if (!isChatAvailable || !window) {
      return;
    }

    window.chat24_token = env.CHAT24_TOKEN;
    window.chat24_url = CONFIG.url;
    window.chat24_socket_url = CONFIG.socket_url;
    window.chat24_static_files_domain = CONFIG.static_files_domain;
    window.lang = CONFIG.lang;
    window.show_new_wysiwyg = CONFIG.show_new_wysiwyg;

    window
      .fetch(`${window.chat24_url}/packs/manifest.json?nocache=${new Date().getTime()}`)
      .then(res => res.json())
      .then(data => {
        const chat24 = document.createElement('script');
        chat24.type = 'text/javascript';
        chat24.async = true;
        chat24.src = `${window.chat24_url}${data['application.js']}`;
        document.body.appendChild(chat24);
        removeBlur();
      });
  }

  inject('chat24', {
    init: chatInitialize,
  });
};
